import {appSettings} from '../../appSettings';

function isLoggingEnabled() {
  return appSettings.enableLogging === true;
}

type LoggerFn = (message?: any, ...optionalParams: any[]) => void;

const noopLogger: LoggerFn = () => {
};

function wrap(logger: LoggerFn): LoggerFn {
  if (isLoggingEnabled())
    return logger;
  return noopLogger;
}

class Logger {
  get log(): LoggerFn {
    return wrap(console.log);
  }

  get error(): LoggerFn {
    return wrap(console.error);
  }

  get warn(): LoggerFn {
    return wrap(console.warn);
  }

  get debug(): LoggerFn {
    return wrap(console.debug);
  }

  get info(): LoggerFn {
    return wrap(console.info);
  }
}

export const logger = new Logger();
